import { Dialog, DialogTitle, DialogContent, DialogContentText } from "@material-ui/core";

export const DeductionInfoModal = ({ title, description, handleClose }: Props) => {
  return (
    <Dialog
      open={true}
      onClose={(_) => handleClose()}
      aria-labelledby="deduction-selection"
      aria-describedby="simple-modal-description"
    >
      <DialogTitle id="simple-dialog-title">{title}</DialogTitle>
      <DialogContent>
        <DialogContentText>{description}</DialogContentText>
      </DialogContent>
    </Dialog>
  );
};

interface Props {
  title: string;
  description: string;
  handleClose: () => void;
}
